import { defineStore } from "pinia";

export const useTemplateApplicationStore = defineStore('templateApplication', {
    state: () => ({
        templateApplication: {},
        templateApplications: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setTemplateApplication(templateApplication) {
            this.templateApplication = templateApplication
        },
        setTemplateApplications(templateApplications) {
            this.templateApplications = templateApplications
        },
        addTemplateApplication(templateApplication) {
            this.templateApplications.unshift(templateApplication)
        },
        updateTemplateApplication(templateApplication) {
            let index = this.templateApplications.findIndex(cl => cl.id === templateApplication.id)
            this.templateApplications.splice(index, 1, templateApplication)
        },
        deleteTemplateApplication(templateApplication) {
            let index = this.templateApplications.findIndex(cl => cl.id === templateApplication.id)
            this.templateApplications.splice(index, 1)
        },
    },
});